import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'getMatchedvalue' })
export class MatchedKeyPipe implements PipeTransform {
    transform(value, args: any): any {
        for (var key in value) {
            if (value[key] != undefined) {
                return value[key][args]; /**Find matched dynamic key value form array*/
            }
        }
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/keyFromArray.pipe.ts